import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateMember, Member } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { memberQueryKeys } from "./keys";


export const useCreateMember = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Member, AxiosError, CreateMember>({
        mutationKey: ["member", "create"],
        mutationFn: async (form: CreateMember) => {
            try {
                const { data } = await memberRepository.create(agentId, form);
                return data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: memberQueryKeys.all(agentId)
            });
        }
    });
};
